/**
 * @license Siftrock
 * (c) 2014-2018 Siftrock, Inc. http://siftrock.com
 * Unauthorized copying of this file, via any medium is strictly prohibited
 */

import { Component, OnInit } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';

import { BsModalService } from 'ngx-bootstrap/modal';

import { AdminService } from '../../services/admin.service';
import { AuthService } from '../../services/auth.service';
import { CacheService } from '../../global/ng2-cache/services/cache.service';
import { SessionService } from '../../services/session2.service';
import { ConfirmDialogComponent } from '../../global/confirm-dialog/confirm-dialog.component';
import { GlobalMessageService } from '../../services/global-message.service';

import { Constants, EmailType } from '../../global/constants';

@Component({
  selector: 'app-admin-job',
  templateUrl: './admin-job.component.html',
  styleUrls: ['./admin-job.component.scss']
})
export class AdminJobComponent implements OnInit {

  id: string;
  tab: any = 'detail';

  loading: any = {
    detail: true,
    history: true,
    audit: true,
    raw: true
  };

  account: any;
  job: any;
  audit: any;

  history: any;
  historyTasks: string[] = [];
  currentTask: string = 'all tasks';
  status: any = [
    {
      id: -1,
      display: 'All Status'
    },
    {
      id: 0,
      display: 'Not run'
    },
    {
      id: 1,
      display: 'Running'
    },
    {
      id: 2,
      display: 'Failed'
    },
    {
      id: 3,
      display: 'Finished'
    },
    {
      id: 99,
      display: 'Paused'
    },
  ];
  currentStatus: any = -1;
  countSelected: number = 0;
  selectAll: boolean = false;

  dba: any = {};

  constructor(private route: ActivatedRoute,
              private cacheService: CacheService,
              private sessionService: SessionService,
              private adminService: AdminService,
              private globalMessageService: GlobalMessageService,
              private constants: Constants,
              private modalService: BsModalService) { }

  ngOnInit() {
    this.route.params.subscribe(
      params => {
        this.id = params['id'];
        if (!this.cacheService.get('session')) {
          this.sessionService.getSession(true).subscribe(
            (session: any) => {
              this.initView();
            }
          )
        }
        else {
          this.initView();
        }
      }
    )
  }

  showAllAuditDetail() {
    this.audit.forEach(a => {
      a.detail = true;
    });
  }

  selectAllHistory() {
    this.selectAll = !this.selectAll;
    this.countSelected = 0;
    this.history.forEach(h => {
      if (!h.pretty.hide) {
        h.pretty.selected = this.selectAll;
        if (h.pretty.selected) {
          this.countSelected++;
        }
      }
    });
  }

  filterHistoryTasks() {
    this.selectAll = false;
    this.history.forEach((h: any) => {
      h.pretty.selected = false;
      let st = h.batch.status;
      if (st==0 && h.batch.retries > 1) {
        st = 2;
      }
      if ((this.currentTask == 'all tasks' || this.currentTask == h.batch.type) &&
          (this.currentStatus == -1) || this.currentStatus == st) {
        h.pretty.hide = false;
      }
      else {
        h.pretty.hide = true;
      }
    });
  }

  refreshJobHistory() {
    this.selectAll = false;
    this.refreshAutomateJobHistory();
  }

  resetBatch(batch: any) {
    let me = this;
    this.modalService.show(ConfirmDialogComponent, Object.assign({}, {
      initialState: {
        message: `Please confirm you would like to reset this batch`,
        confirm: function() {
          me.resetOneBatch(batch._id).then(() => {
            me.refreshAutomateJobHistory();
            me.globalMessageService.message('Batch was reset');
          });
        }
      }
    }));
  }

  resetBatches() {
    let me = this;
    let selected = [];
    this.history.forEach(h => {
      if (h.pretty.selected) {
        selected.push(h);
      }
    });

    this.modalService.show(ConfirmDialogComponent, Object.assign({}, {
      initialState: {
        message: `Please confirm you would like to reset the selected batches (${selected.length} selected)`,
        confirm: function() {
          Promise.all(selected.map(h => {
            return me.resetOneBatch(h.batch._id);
          }))
          .then(() => {
            me.countSelected = 0;
            me.refreshAutomateJobHistory();
            me.globalMessageService.message(`${selected.length} batch(es) were reset`);
          });
        }
      }
    }));
  }

  pauseBatch(batch: any) {
    let me = this;
    this.modalService.show(ConfirmDialogComponent, Object.assign({}, {
      initialState: {
        message: `Please confirm you would like to pause this batch`,
        confirm: function() {
          me.pauseOneBatch(batch._id).then(() => {
            me.refreshAutomateJobHistory();
            me.globalMessageService.message('Batch was paused');
          });
        }
      }
    }));
  }

  pauseBatches() {
    let me = this;
    let selected = [];
    this.history.forEach(h => {
      if (h.pretty.selected) {
        selected.push(h);
      }
    });

    this.modalService.show(ConfirmDialogComponent, Object.assign({}, {
      initialState: {
        message: `Please confirm you would like to pause the selected batches (${selected.length} selected)`,
        confirm: function() {
          Promise.all(selected.map(h => {
            return me.pauseOneBatch(h.batch._id);
          }))
          .then(() => {
            me.countSelected = 0;
            me.refreshAutomateJobHistory();
            me.globalMessageService.message(`${selected.length} batch(es) were paused`);
          });
        }
      }
    }));
  }

  deleteBatch(batch: any) {
    let me = this;
    this.modalService.show(ConfirmDialogComponent, Object.assign({}, {
      initialState: {
        message: `Please confirm you would like to delete this batch`,
        confirm: function() {
          me.deleteOneBatch(batch._id).then(() => {
            me.refreshAutomateJobHistory();
            me.globalMessageService.message('Batch was deleted');
          });
        }
      }
    }));
  }

  deleteBatches() {
    let me = this;
    let selected = [];
    this.history.forEach(h => {
      if (h.pretty.selected) {
        selected.push(h);
      }
    });

    this.modalService.show(ConfirmDialogComponent, Object.assign({}, {
      initialState: {
        message: `Please confirm you would like to delete the selected batches (${selected.length} selected)`,
        confirm: function() {
          Promise.all(selected.map(h => {
            return me.deleteOneBatch(h.batch._id);
          }))
          .then(() => {
            me.countSelected = 0;
            me.refreshAutomateJobHistory();
            me.globalMessageService.message(`${selected.length} batch(es) were deleted`);
          });
        }
      }
    }));
  }

  selectHistoryItem(item: any) {
    item.pretty.selected = !item.pretty.selected;
    if (item.pretty.selected) {
      this.countSelected++;
    }
    else {
      this.countSelected--;
    }
  }

  getIntegrationlog(historyItem) {
    if (!historyItem.integration_log) {
      this.adminService.getIntegrationLog(historyItem.batch.requestId).subscribe(
        (results: any) => {
          historyItem.integration_log = results;
          historyItem.integration_log.sort((a, b) => {
            if (a.created_at < b.created_at) {
              return -1;
            }
            else {
              return 1;
            }
          });
          historyItem.pretty.integration_log = true;
        }
      )
    }
    else {
      historyItem.pretty.integration_log = true;
    }
  }

  initView() {
    this.adminService.getJob(this.id).subscribe(
      (result: any) => {
        this.job = result;
        this.job.filters.forEach(f => {
          this.dba.jobFind = `db.automate_job.find({_id: ObjectId('${this.job._id}')}).pretty()`;
          this.dba.jobAudit = `db.automate_job_audit.find({_id: ObjectId('${this.job._id}')}).pretty()`;
          this.dba.recentBatch = `db.batch_q.find({automate_job_id: ObjectId('${this.job._id}')}).sort({created_at: -1}).limit(1).pretty()`;

          this.dba.taskHistory = [];

          this.job.tasks.forEach(task => {
            this.dba.taskHistory.push({
              taskId: task.taskId,
              task: task.type,
              query: `db.automate_task_history.find({tId: '${task.taskId}'}).sort({created_at: -1}).limit(1).pretty()`
            });
          });
        });
        this.adminService.getAccount(this.job.account_id).subscribe(
          (a: any) => {
            this.account = a;
            this.dba.accountFind = `db.account.find({_id: ObjectId('${this.account._id}')}).pretty()`;
            this.loading.detail = false;
            this.loading.raw = false;
          }
        )
      }
    )

    this.adminService.getAutomateJobAuditHistory(this.id).subscribe(
      (result: any) => {
        this.audit = result;
        this.loading.audit = false;
      }
    )

    this.refreshAutomateJobHistory();
  }

  /**
   * Add custom output for keys/values that are more complex
   * @param type
   * @param item
   */
  customChangeOutput(type, item) {
    if (type=='settings.static') {
      return item.map(i=> { return i.email_address}).join(' | ');
    }
    if (type=='settings.siftrock_fields' || type=='settings.static_fields') {
      return item.display;
    }
    if (type=='settings.lead_owner.field') {
      return item.display;
    }
    if (type=='settings.lead_owner.fallback') {
      return item.join(' | ');
    }
    return item;
  }

  private refreshAutomateJobHistory() {
    this.loading.history = true;
    this.adminService.getAutomateJobHistory(this.id).subscribe(
      (result: any) => {
        let temp = result;
        this.history = [];
        this.historyTasks = ['all tasks'];
        temp.forEach(h => {
          let t = {
            batch: h,
            pretty: {
              hide: false,
              detail: false,
              dba: {
                batchQ: `db.batch_q.find({_id: ObjectId('${h._id}')}).pretty()`,
                integrationLog: `db.integration_log.find({requestId: '${h.requestId}'}).pretty()`
              },
              raw: false,
              integration_log: false,
              selected: false
            }
          };

          this.history.push(t);
          if (this.historyTasks.findIndex(ht => { return ht == h.type}) < 0) {
            this.historyTasks.push(h.type);
          }
        });
        this.loading.history = false;
      }
    )
  }

  private resetOneBatch(batchId: string): Promise<any> {
    return new Promise((resolve, reject) => {
      this.adminService.resetTaskBatch(batchId).subscribe(
        (result: any) => {
          resolve();
        },
        error => {
          reject();
        }
      )
    });
  }

  private pauseOneBatch(batchId: string): Promise<any> {
    return new Promise((resolve, reject) => {
      this.adminService.pauseTaskBatch(batchId).subscribe(
        (result: any) => {
          resolve();
        },
        error => {
          reject();
        }
      )
    });
  }

  private deleteOneBatch(batchId: string): Promise<any> {
    return new Promise((resolve, reject) => {
      this.adminService.deleteTaskBatch(batchId).subscribe(
        (result: any) => {
          resolve();
        },
        error => {
          reject();
        }
      )
    });
  }
}



// WEBPACK FOOTER //
// ./client/app/admin/admin-job/admin-job.component.ts